import { createBrowserRouter, Navigate } from "react-router-dom";
import AppShell from "../layout/AppShell";
import AdminShell from "../layout/AdminShell";
import AdminLoginPage from "../pages/admin/AdminLoginPage";
import RequireAdmin from "./RequireAdmin";
import RequireAuth from "./RequireAuth";
import CodingAssistantPage from "../pages/CodingAssistantPage";
import DashboardPage from "../pages/DashboardPage";
import UserDashboardPage from "../pages/UserDashboardPage";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import NotFound from "../components/notfound/NotFound";
import LandingPage from "../pages/LandingPage";
import AccountPage from "../pages/AccountPage";
import BillingPage from "../pages/BillingPage";
import LegalPage from "../pages/LegalPage";
import TermsOfServicePage from "../pages/TermsOfServicePage";
import SecondPairOfEyesPage from "../pages/SecondPairOfEyesPage";

const routers = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/legal", element: <LegalPage /> },
  { path: "/terms-of-service", element: <TermsOfServicePage /> },
  {
    path: "/build",
    element: <AppShell />,
    children: [
        { index: true, element: <CodingAssistantPage /> },
        // The User Dashboard: any signed-in user, their own projects only.
        // Deliberately a different page from the admin console below.
        {
          path: "/build/dashboard",
          element: (
            <RequireAuth>
              <UserDashboardPage />
            </RequireAuth>
          ),
        },
        // Second Pair of Eyes: check a completed build against one of the
        // user's own approved blueprints. Part of the project dashboard.
        {
          path: "/build/projects/:sessionId/second-pair-of-eyes",
          element: (
            <RequireAuth>
              <SecondPairOfEyesPage />
            </RequireAuth>
          ),
        },
        // Billing and Account: signed-in users only.
        {
          path: "/build/billing",
          element: (
            <RequireAuth>
              <BillingPage />
            </RequireAuth>
          ),
        },
        {
          path: "/build/account",
          element: (
            <RequireAuth>
              <AccountPage />
            </RequireAuth>
          ),
        },
        // Profile was the old name for Account; keep old links working.
        { path: "/build/profile", element: <Navigate to="/build/account" replace /> },
        { path: "/build/login", element: <LoginPage /> },
        { path: "/build/register", element: <RegisterPage /> }
    ],
  },
  // Admin console lives outside /build: its own shell, no product nav.
  {
    path: "/admin",
    element: <AdminShell />,
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: "/admin/login", element: <AdminLoginPage /> },
      {
        path: "/admin/dashboard",
        element: (
          <RequireAdmin>
            <DashboardPage />
          </RequireAdmin>
        ),
      },
    ],
  },
  // Convenience redirects: common paths typed without the /build prefix.
  { path: "/dashboard", element: <Navigate to="/build/dashboard" replace /> },
  { path: "/profile", element: <Navigate to="/build/account" replace /> },
  { path: "/account", element: <Navigate to="/build/account" replace /> },
  { path: "/billing", element: <Navigate to="/build/billing" replace /> },
  { path: "/login", element: <Navigate to="/build/login" replace /> },
  { path: "/register", element: <Navigate to="/build/register" replace /> },
  { path: "*", element: <NotFound /> },
]);

export default routers;
